import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import malaysia from '../../images/flags/malaysia.svg'
import singapore from '../../images/flags/singapore.svg'
import india from '../../images/flags/india.svg'
import australia from '../../images/flags/australia.svg'
import uae from '../../images/flags/uae.svg'
import ksa from '../../images/flags/ksa.svg'

const partners = [
    {
        pImg: malaysia,
        label: 'Malaysia',
    },
    {
        pImg: singapore,
        label: 'Singapore',
    },
    {
        pImg: india,
        label: 'India',
    },
    {
        pImg: australia,
        label: 'Australia',
    },
    {
        pImg: uae,
        label: 'UAE',
    },
    {
        pImg: ksa,
        label: 'KSA',
    },
    {
        pImg: malaysia,
        label: 'Malaysia',
    },
    {
        pImg: india,
        label: 'India',
    },
]

var settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,

    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 7,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 350,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};



const PartnerSection = (props) => {

    return (
        <div className="client_logo_carousel">
            <Slider {...settings}>
                {partners.map((partner, pitem) => (
                    <div className="client_logo_item country_logo_item" key={pitem}>
                        <img src={partner.pImg} alt={`${partner.label} flag`} />
                        <span>{partner.label}</span>
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default PartnerSection;
